import {gql} from '@apollo/client'

export const MOVE_KANBAN_TASK = gql`
  mutation MoveKanbanTask($id: ID!, $toStageId: ID!, $position: Int) {
    moveKanbanTask(id: $id, toStageId: $toStageId, position: $position) {
      ok
      errors
      task {
        id
        position
        stage {
          id
          name
        }
      }
    }
  }
`

export const CREATE_KANBAN_STAGE = gql`
  mutation CreateKanbanStage(
    $workflowId: ID!
    $name: String!
    $description: String
    $color: String
    $isClosedState: Boolean
    $position: Int
  ) {
    createKanbanStage(
      workflowId: $workflowId
      name: $name
      description: $description
      color: $color
      isClosedState: $isClosedState
      position: $position
    ) {
      ok
      errors
      stage {
        id
        name
        description
        position
        color
        wipLimit
        isClosedState
      }
    }
  }
`

export const UPDATE_KANBAN_STAGE = gql`
  mutation UpdateKanbanStage(
    $id: ID!
    $name: String
    $description: String
    $color: String
    $isClosedState: Boolean
    $position: Int
  ) {
    updateKanbanStage(
      id: $id
      name: $name
      description: $description
      color: $color
      isClosedState: $isClosedState
      position: $position
    ) {
      ok
      errors
      stage {
        id
        name
        description
        color
        isClosedState
      }
    }
  }
`

export const DELETE_KANBAN_STAGE = gql`
  mutation DeleteKanbanStage($id: ID!) {
    deleteKanbanStage(id: $id) {
      ok
      errors
    }
  }
`

export const CREATE_KANBAN_WORKFLOW = gql`
  mutation CreateKanbanWorkflow(
    $name: String!
    $description: String
    $groupAssignmentIds: [ID!]
    $sharedUserIds: [ID!]
    $visibility: String
    $withDefaultStages: Boolean
  ) {
    createKanbanWorkflow(
      name: $name
      description: $description
      groupAssignmentIds: $groupAssignmentIds
      sharedUserIds: $sharedUserIds
      visibility: $visibility
      withDefaultStages: $withDefaultStages
    ) {
      ok
      errors
      workflow {
        id
        name
        description
        visibility
        isArchived
      }
    }
  }
`

export const UPDATE_KANBAN_WORKFLOW = gql`
  mutation UpdateKanbanWorkflow(
    $id: ID!
    $name: String
    $description: String
    $visibility: String
    $groupAssignmentIds: [ID!]
    $sharedUserIds: [ID!]
  ) {
    updateKanbanWorkflow(
      id: $id
      name: $name
      description: $description
      visibility: $visibility
      groupAssignmentIds: $groupAssignmentIds
      sharedUserIds: $sharedUserIds
    ) {
      ok
      errors
      workflow {
        id
        name
        description
        visibility
        isArchived
      }
    }
  }
`

export const DELETE_KANBAN_WORKFLOW = gql`
  mutation DeleteKanbanWorkflow($id: ID!) {
    deleteKanbanWorkflow(id: $id) {
      ok
      errors
    }
  }
`

export const CREATE_KANBAN_TASK = gql`
  mutation CreateKanbanTask(
    $workflowId: ID!
    $stageId: ID!
    $assignmentGroupId: ID
    $title: String!
    $description: String
    $dueDate: DateTime
    $assigneeId: ID
    $tagColor: String
    $labelText: String
    $priority: String
  ) {
    createKanbanTask(
      workflowId: $workflowId
      stageId: $stageId
      assignmentGroupId: $assignmentGroupId
      title: $title
      description: $description
      dueDate: $dueDate
      assigneeId: $assigneeId
      tagColor: $tagColor
      labelText: $labelText
      priority: $priority
    ) {
      ok
      errors
      task {
        id
        title
        description
        position
        tagColor
        labelText
        priority
        dueDate
        isCompleted
        stage {
          id
          name
        }
        assignmentGroup {
          id
          name
        }
        assignee {
          id
          firstName
          lastName
        }
      }
    }
  }
`

export const CREATE_KANBAN_TASK_ATTACHMENT = gql`
  mutation CreateKanbanTaskAttachment($taskId: ID!, $file: Upload!, $description: String) {
    createKanbanTaskAttachment(taskId: $taskId, file: $file, description: $description) {
      ok
      errors
      attachment {
        id
        originalName
        description
        file
        fileSize
        contentType
        createdAt
        uploadedBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`

export const DELETE_KANBAN_TASK_ATTACHMENT = gql`
  mutation DeleteKanbanTaskAttachment($id: ID!) {
    deleteKanbanTaskAttachment(id: $id) {
      ok
      errors
    }
  }
`

export const ADD_KANBAN_CHECKLIST_ITEM = gql`
  mutation AddKanbanChecklistItem($taskId: ID!, $title: String!, $dueDate: DateTime) {
    addKanbanChecklistItem(taskId: $taskId, title: $title, dueDate: $dueDate) {
      ok
      errors
      item {
        id
        title
        isCompleted
      }
    }
  }
`

export const TOGGLE_KANBAN_CHECKLIST_ITEM = gql`
  mutation ToggleKanbanChecklistItem($id: ID!, $isCompleted: Boolean!) {
    toggleKanbanChecklistItem(id: $id, isCompleted: $isCompleted) {
      ok
      errors
      item {
        id
        title
        isCompleted
      }
    }
  }
`

export const UPDATE_KANBAN_CHECKLIST_ITEM = gql`
  mutation UpdateKanbanChecklistItem($id: ID!, $title: String!) {
    updateKanbanChecklistItem(id: $id, title: $title) {
      ok
      errors
      item {
        id
        title
        isCompleted
      }
    }
  }
`

export const DELETE_KANBAN_CHECKLIST_ITEM = gql`
  mutation DeleteKanbanChecklistItem($id: ID!) {
    deleteKanbanChecklistItem(id: $id) {
      ok
      errors
    }
  }
`

export const UPDATE_KANBAN_TASK = gql`
  mutation UpdateKanbanTask(
    $id: ID!
    $title: String
    $description: String
    $dueDate: DateTime
    $tagColor: String
    $labelText: String
    $assignmentGroupId: ID
    $priority: String
  ) {
    updateKanbanTask(
      id: $id
      title: $title
      description: $description
      dueDate: $dueDate
      tagColor: $tagColor
      labelText: $labelText
      assignmentGroupId: $assignmentGroupId
      priority: $priority
    ) {
      ok
      errors
      task {
        id
        title
        description
        dueDate
        tagColor
        labelText
        priority
        assignmentGroup {
          id
          name
        }
      }
    }
  }
`

export const CREATE_KANBAN_COMMENT = gql`
  mutation CreateKanbanComment($taskId: ID!, $body: String!, $isInternal: Boolean) {
    createKanbanComment(taskId: $taskId, body: $body, isInternal: $isInternal) {
      ok
      errors
      comment {
        id
        body
        createdAt
        author {
          id
          firstName
          lastName
        }
      }
    }
  }
`

export const UPDATE_KANBAN_COMMENT = gql`
  mutation UpdateKanbanComment($id: ID!, $body: String!) {
    updateKanbanComment(id: $id, body: $body) {
      ok
      errors
      comment {
        id
        body
        createdAt
        author {
          id
          firstName
          lastName
        }
      }
    }
  }
`

export const DELETE_KANBAN_COMMENT = gql`
  mutation DeleteKanbanComment($id: ID!) {
    deleteKanbanComment(id: $id) {
      ok
      errors
    }
  }
`

export const COMPLETE_KANBAN_TASK = gql`
  mutation CompleteKanbanTask($id: ID!, $isCompleted: Boolean!) {
    completeKanbanTask(id: $id, isCompleted: $isCompleted) {
      ok
      errors
      task {
        id
        isCompleted
        completedAt
      }
      comment {
        id
        body
        createdAt
        isInternal
        author {
          id
          firstName
          lastName
        }
      }
    }
  }
`

export const ADD_KANBAN_PARTICIPANT = gql`
  mutation AddKanbanParticipant($taskId: ID!, $userId: ID!, $role: String) {
    addKanbanParticipant(taskId: $taskId, userId: $userId, role: $role) {
      ok
      errors
      participant {
        id
        role
        user {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`

export const REMOVE_KANBAN_PARTICIPANT = gql`
  mutation RemoveKanbanParticipant($taskId: ID!, $userId: ID!) {
    removeKanbanParticipant(taskId: $taskId, userId: $userId) {
      ok
      errors
    }
  }
`

export const ARCHIVE_KANBAN_TASK = gql`
  mutation ArchiveKanbanTask($id: ID!, $isArchived: Boolean) {
    archiveKanbanTask(id: $id, isArchived: $isArchived) {
      ok
      errors
      task {
        id
        isArchived
        archivedAt
      }
    }
  }
`

export const DELETE_KANBAN_TASK = gql`
  mutation DeleteKanbanTask($id: ID!) {
    deleteKanbanTask(id: $id) {
      ok
      errors
    }
  }
`
